import { Box, styled } from "@mui/material";
import { Typography } from "components";
import { base, gray } from "configs/colors";
import { shadows } from "configs/shadows";
import CountUp from "react-countup";
import { lineHeight, rem } from "utils";

const SummaryCard = styled(Box)`
  background-color: ${base.White};
  border-radius: 12px;
  border: 1px solid ${gray[200]};
  box-shadow: ${shadows.xs};
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  justify-content: space-between;
  padding: 24px;
`;

const SummaryAmount = styled("span")`
  font-size: ${rem(36)};
  font-weight: 600;
  line-height: ${lineHeight(44)}
  letter-spacing: -0.72px;
`;

interface Props {
  title: string;
  value: number;
}

const IndexComponent: React.FC<Props> = ({ title, value }) => (
  <SummaryCard>
    <Typography type="TextXS" fontWeight={500}>
      {title}
    </Typography>
    <CountUp start={0} end={value} delay={0}>
      {({ countUpRef }) => <SummaryAmount ref={countUpRef} />}
    </CountUp>
  </SummaryCard>
);

export default IndexComponent;
